webpackJsonp([33146255954607],{

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(47);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGroup = function FaGroup(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm12.3 20q-3.4 0.1-5.5 2.7h-2.8q-1.7 0-2.8-0.9t-1.2-2.4q0-7.4 2.6-7.4 0.1 0 0.9 0.5t2 0.8 2.5 0.5q1.4 0 2.7-0.5-0.1 0.8-0.1 1.4 0 2.9 1.7 5.3z m22.3 13.2q0 2.5-1.6 4t-4 1.4h-18.1q-2.6 0-4.1-1.4t-1.5-4q0-1.1 0.1-2.1t0.3-2.3 0.5-2.2 0.9-2.1 1.3-1.6 1.8-1.2 2.3-0.4q0.2 0 0.9 0.5t1.5 1 2.2 1 2.8 0.4 2.8-0.4 2.3-1 1.5-1 0.9-0.5q1.2 0 2.3 0.4t1.8 1.2 1.2 1.6 0.9 2.1 0.6 2.2 0.3 2.3 0.1 2.1z m-21.3-26.5q0 2.2-1.6 3.8t-3.7 1.5-3.8-1.5-1.5-3.8 1.5-3.7 3.8-1.6 3.7 1.6 1.6 3.7z m14.6 8q0 3.3-2.3 5.6t-5.7 2.4-5.6-2.4-2.3-5.6 2.3-5.7 5.6-2.3 5.7 2.3 2.3 5.7z m12 4.7q0 1.6-1.2 2.4t-2.9 0.9h-2.7q-2.2-2.6-5.5-2.7 1.6-2.4 1.6-5.3 0-0.6-0.1-1.4 1.4 0.5 2.8 0.5 1.2 0 2.5-0.5t2-0.8 0.9-0.5q2.6 0 2.6 7.4z m-2.7-12.7q0 2.2-1.5 3.8t-3.8 1.5-3.8-1.5-1.5-3.8 1.5-3.7 3.8-1.6 3.8 1.6 1.5 3.7z' })
	        )
	    );
	};
	
	exports.default = FaGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _group = __webpack_require__(640);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _bloomer = __webpack_require__(16);
	
	var _Pageheader = __webpack_require__(26);
	
	var _Pageheader2 = _interopRequireDefault(_Pageheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EquipsEsplaisPage = function EquipsEsplaisPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Pageheader2.default, {
	      title: 'Equips d\'esplais',
	      subtitle: 'Coneix amb quins esplais fas les activitats'
	    }),
	    _react2.default.createElement(
	      _bloomer.Section,
	      null,
	      _react2.default.createElement(_bloomer.Container, { isFluid: true }),
	      data.allContentfulEquipsEsplais.edges.map(function (_ref2, i) {
	        var node = _ref2.node;
	        return _react2.default.createElement(
	          _bloomer.Box,
	          { key: node.id },
	          _react2.default.createElement(
	            _bloomer.Title,
	            { isSize: '4' },
	            node.titol
	          ),
	          _react2.default.createElement(
	            _bloomer.Columns,
	            { isMultiline: true, isMobile: true },
	            node.esplais.map(function (esplai, i) {
	              return _react2.default.createElement(
	                _bloomer.Column,
	                { isSize: '1/2', key: i },
	                _react2.default.createElement(
	                  _bloomer.Columns,
	                  { isMobile: true, isGapless: true, isMarginless: true },
	                  _react2.default.createElement(
	                    _bloomer.Column,
	                    { isSize: '1/3' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'my-icon-container' },
	                      _react2.default.createElement(_group2.default, { height: '1.25em', width: '1.25em', fill: '#00A2A7' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _bloomer.Column,
	                    null,
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      esplai
	                    )
	                  )
	                )
	              );
	            }),
	            _react2.default.createElement(
	              _bloomer.Column,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: node.slug },
	                _react2.default.createElement(
	                  _bloomer.Button,
	                  { isColor: 'primary', isDisplay: 'flex' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Tota la informaci\xF3 de l\'',
	                    node.titol
	                  )
	                )
	              )
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = EquipsEsplaisPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-equips-esplais-js-d053e28b18ac5daf96b5.js